import { injectIntl } from "react-intl";
import { Formik } from "formik";
import {
  intlShape,
  Form,
  CancelButton,
  SubmitButton,
  TextInput,
  ButtonGroup,
  SelectBox,
  DateInput,
  isValidDecimalSeparator,
  isValidFloat,
  parseIntlNumber,
  CountriesSelectFormik,
} from "lcm-iot-commons";

type OwnProps = {
  intl: intlShape;
  onSubmit?: $TSFixMeFunction;
  initialValues?: {
    startDate?: $TSFixMe; // TODO: PropTypes.instanceOf(Date)
    country?: {
      [key: string]: string;
    };
    rate?: string;
    type?: {
      [key: string]: string;
    };
  };
};

const defaultProps: Partial<OwnProps> = {
  onSubmit: undefined,
  initialValues: {
    startDate: new Date(),
    country: { code: "AF" },
    rate: undefined,
    type: { id: "withholding" },
  },
};

type Props = OwnProps & typeof defaultProps;

export function TaxForm({ intl, onSubmit, initialValues }: Props) {
  const validateForm = (values: $TSFixMe) => {
    const errors = {};
    if (!values.startDate) {
      (errors as $TSFixMe).startDate = intl.formatMessage({
        id: "validation.taxes.start_date_mandatory",
      });
    }
    if (
      values.startDate &&
      values.endDate &&
      values.startDate.getTime() > values.endDate.getTime()
    ) {
      (errors as $TSFixMe).endDate = intl.formatMessage({
        id: "validation.taxes.start_date_later_than_end_date",
      });
    }
    if (!values.rate) {
      (errors as $TSFixMe).rate = intl.formatMessage({
        id: "validation.taxes.rate_mandatory",
      });
    } else if (
      !isValidDecimalSeparator(values.rate) ||
      !isValidFloat(values.rate)
    ) {
      (errors as $TSFixMe).rate = intl.formatMessage({
        id: "validation.number.invalid",
      });
    } else {
      const rateValue = parseIntlNumber(values.rate);
      if (rateValue < 0 || rateValue > 100) {
        (errors as $TSFixMe).rate = intl.formatMessage({
          id: "validation.tax.must_be_between_0_and_100",
        });
      }
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form {...formProps}>
        <DateInput
          {...formProps}
          id="tax-start-date"
          name="startDate"
          label={intl.formatMessage({ id: "label.tax.start_date" })}
          required
        />
        <DateInput
          {...formProps}
          id="tax-end-date"
          name="endDate"
          placeholder={intl.formatMessage({
            id: "taxes.never_expires_when_empty",
          })}
          label={intl.formatMessage({ id: "label.tax.end_date" })}
        />
        <CountriesSelectFormik
          {...formProps}
          id="tax-country"
          name="country"
          label={intl.formatMessage({ id: "label.tax.country" })}
          all
        />
        <SelectBox
          {...formProps}
          id="tax-type"
          name="type"
          label={intl.formatMessage({ id: "label.tax.type" })}
          options={[
            {
              id: "withholding",
              name: intl.formatMessage({ id: "enum.taxes.withholding" }),
            },
          ]}
        />
        <TextInput
          {...formProps}
          id="tax-rate"
          name="rate"
          label={intl.formatMessage({ id: "label.tax.rate" })}
          required
        />
        {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element[]; className: string; }'... Remove this comment to see the full error message */}
        <ButtonGroup className="btn-group">
          <SubmitButton
            id="tax-submit"
            fetching={isSubmitting}
            disabled={!formProps.dirty}
          />
          {/* @ts-expect-error TS(2322) FIXME: Type '{ id: string; disabled: any; intl: IntlShape... Remove this comment to see the full error message */}
          <CancelButton id="tax-cancel" disabled={isSubmitting} intl={intl} />
        </ButtonGroup>
      </Form>
    );
  };

  return (
    <Formik
      id="tax-form"
      initialValues={initialValues}
      // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
      onSubmit={onSubmit}
      validate={validateForm}
    >
      {renderForm}
    </Formik>
  );
}

TaxForm.defaultProps = defaultProps;

export default injectIntl(TaxForm);
